var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon /Icon / CloseOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1401 1.827C13.1405 1.827 13.1409 1.82735 13.1416 1.82807L14.1718 2.85843C14.1725 2.85896 14.1726 2.85932 14.1728 2.85985C14.1729 2.86021 14.1729 2.86057 14.1728 2.86093C14.1728 2.86146 14.1725 2.86182 14.1718 2.86253L9.03425 8.00003L14.1718 13.1375C14.1725 13.1382 14.1726 13.1386 14.1728 13.1391C14.1729 13.1395 14.1729 13.14 14.1728 13.1404C14.1728 13.1407 14.1725 13.1411 14.1718 13.1418L13.1414 14.172C13.1409 14.1727 13.1405 14.1729 13.1401 14.1731C13.1397 14.1732 13.1393 14.1732 13.1389 14.1731C13.1384 14.1731 13.138 14.1727 13.1373 14.172L7.99979 9.0345L2.86229 14.172C2.86157 14.1727 2.86122 14.1729 2.86068 14.1731C2.86027 14.1732 2.85984 14.1732 2.85943 14.1731C2.85907 14.1731 2.85872 14.1727 2.858 14.172L1.82782 13.1416C1.82711 13.1411 1.82693 13.1407 1.82675 13.1404C1.82663 13.14 1.82663 13.1395 1.82675 13.1391C1.82675 13.1386 1.82711 13.1382 1.82782 13.1375L6.96532 8.00003L1.82782 2.86253C1.82711 2.86182 1.82693 2.86146 1.82675 2.86093C1.82663 2.86052 1.82663 2.86008 1.82675 2.85968C1.82675 2.85932 1.82711 2.85896 1.82782 2.85825L2.85818 1.82807C2.85872 1.82735 2.85907 1.82718 2.85943 1.827C2.85984 1.82687 2.86027 1.82687 2.86068 1.827C2.86122 1.827 2.86157 1.82735 2.86229 1.82807L7.99979 6.96557L13.1373 1.82807C13.138 1.82735 13.1384 1.82718 13.1389 1.827C13.1393 1.82687 13.1397 1.82687 13.1401 1.827Z",
    fill: "black",
    fillOpacity: 0.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/CloseOutlined.f78626fe9f3d7e62d1b6a4a4d676afaa.svg";
export { ForwardRef as ReactComponent };